import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useSubmitSuccessEvent } from "../../contexts/events-context.js";
import { useTranslation } from "../../contexts/translation-context.js";
import { formatAppointmentSubmission } from "./actions/format-appointment-submission/index.js";
import { DataStatus } from "./appointment-state.js";
import { classes } from "./appointment.st.css";
import { AppointmentContextProvider, useAppointmentContext } from "./context/appointment-context.js";
import { Loader } from "./loader/index.js";
import { Notification } from "./notification/index.js";
import { TimeSlotPicker } from "./time-slot-picker/index.js";
import { Fieldset } from "../fieldset/fieldset.js";
function AppointmentFieldWUT(props) {
  const {
    onFocus,
    onBlur,
    inputId,
    ariaLabelledBy,
    ariaDescribedBy,
    required
  } = props;
  return /* @__PURE__ */ jsx(
    Fieldset,
    {
      id: inputId,
      onFocus,
      onBlur,
      ariaLabelledBy,
      ariaDescribedBy,
      required,
      children: /* @__PURE__ */ jsx(AppointmentContextProvider, { appointmentFieldProps: props, children: /* @__PURE__ */ jsx(RenderField, {}) })
    }
  );
}
const RenderField = () => {
  const { appointmentFieldProps, appointmentState, setAppointmentState } = useAppointmentContext();
  const { t } = useTranslation();
  const {
    onChange,
    value: selectedSlot,
    target,
    fieldId
  } = appointmentFieldProps;
  useSubmitSuccessEvent((values) => {
    const submittedSlot = values?.[target];
    if (appointmentState?.availabilitySlots?.length) {
      const availabilitySlots = appointmentState.availabilitySlots.filter(
        (slot) => slot?.slot?.startDate !== submittedSlot?.startDate
      );
      setAppointmentState({
        availabilitySlots
      });
    }
  });
  useEffect(() => {
    if (onChange) {
      onChange(formatAppointmentSubmission(selectedSlot));
    }
  }, [
    selectedSlot?.startDate,
    selectedSlot?.endDate,
    appointmentState?.timezone
  ]);
  if (appointmentState?.error) {
    console.error("Error in appointment state", appointmentState.error);
  }
  if (appointmentState?.error) {
    return /* @__PURE__ */ jsx(
      Notification,
      {
        message: t("form.appointment.empty-state.notification.text")
      }
    );
  }
  if (appointmentState?.dataStatus === DataStatus.LOADING) {
    return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
      /* @__PURE__ */ jsx("div", { className: classes.verticalCenterLoader, children: /* @__PURE__ */ jsx(Loader, {}) }),
      /* @__PURE__ */ jsx(TimeSlotPicker, { visibility: "hidden" })
    ] });
  }
  return /* @__PURE__ */ jsx("div", { className: classes.root, children: /* @__PURE__ */ jsx(TimeSlotPicker, { fieldId }) });
};
export {
  AppointmentFieldWUT
};
//# sourceMappingURL=appointment.js.map
